import layout2 from './layout2/Layout2Config';

const FuseLayoutConfigs = {
	layout2
};

export default FuseLayoutConfigs;
